import { Stack, IconButton } from "@mui/material";
import {
  FacebookTwoTone,
  Instagram,
} from "@mui/icons-material";
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useDomainConfig } from "../utils/domainConfigProvider";

function SocialIcons({ color = null }) {
  const { domainConfig } = useDomainConfig();
  return (
    <Stack
      direction="row"
      spacing={1}
    >
      {domainConfig !== null && domainConfig.fbUrl && (
        <IconButton
          size="small"
          component="a"
          target="_blank"
          href={domainConfig?.fbUrl}
        >
          <FacebookTwoTone color="primary" />
        </IconButton>
      )}

      {domainConfig !== null && domainConfig.instaUrl && (
        <IconButton
          size="small"
          component="a"
          target="_blank"
          href={domainConfig?.instaUrl}
        >
          <Instagram color="error" />
        </IconButton>
      )}

      {domainConfig !== null && domainConfig.twitterUrl && (
        <IconButton
          size="small"
          component="a"
          target="_blank"
          href={domainConfig?.twitterUrl}
        >
          <XIcon color="black" fontSize="small" />
        </IconButton>
      )}

      {domainConfig !== null && domainConfig.linkedinUrl && (
        <IconButton
          size="small"
          component="a"
          target="_blank"
          href={domainConfig?.linkedinUrl}
        >
          <LinkedInIcon color="primary" />
        </IconButton>
      )}

      {domainConfig !== null && domainConfig.whatsappNumber && (
        <IconButton
          size="small"
          component="a"
          target="_blank"
          href={`https://wa.me/${domainConfig?.whatsappNumber}`}
        >
          <WhatsAppIcon sx={{ color: '#25D366' }} />
        </IconButton>
      )}
    </Stack>
  );
}

export default SocialIcons;
